import { WidgetType } from "@/api/types";

export const CONSENT_LIST: ServiceData[] = [
  {
    id: "openweather",
    name: "OpenWeatherMap",
    description: "consent.openweather_description",
    type: "api",
    dataTheyGet: ["consent.item_ip_address", "consent.item_browser", "consent.item_os", "consent.item_referrer", "consent.item_date_time"],
  },
  {
    id: "openstreet",
    name: "OpenStreetMap",
    description: "consent.openstreet_description",
    type: "api",
    dataTheyGet: ["consent.item_ip_address", "consent.item_browser", "consent.item_os", "consent.item_referrer", "consent.item_date_time"],
  },
  {
    id: "photon",
    name: "Photon",
    description: "consent.photon_description",
    type: "api",
    dataTheyGet: ["consent.item_ip_address", "consent.item_browser", "consent.item_os", "consent.item_referrer", "consent.item_date_time"],
  },
] as const;

export type ServiceData = {
  id: SERVICE_ID;
  name: string;
  description: string;
  type: string;
  dataTheyGet: string[];
};

export type SERVICE_ID = "openweather" | "openstreet" | "photon" | "firebase";

export const WIDGET_SERVICE_CONSENT_MAPPING: WidgetServiceMapping = {
  map: ["openstreet"],
  weather: ["openweather", "photon"],
};

export type WidgetServiceMapping = {
  [K in "map" | "weather" as WidgetType]?: SERVICE_ID[];
};
